export type ChatMessage = {
    isUser: boolean;          
    text: string;
    timestamp: number;         
    agentName?: string;   
};

const keyFor = (sessionId: string) => `chatbot_history_${sessionId}`;

export function loadHistory(sessionId: string): ChatMessage[] {
    if (typeof window === "undefined") return [];
    try {
        const raw = window.localStorage.getItem(keyFor(sessionId));
        return raw ? (JSON.parse(raw) as ChatMessage[]) : [];
    } catch { return []; }
}

export function saveHistory(sessionId: string, msgs: ChatMessage[]) {
    try { window.localStorage.setItem(keyFor(sessionId), JSON.stringify(msgs)); } catch { }
}

export function clearHistory(sessionId: string) {
    try { window.localStorage.removeItem(keyFor(sessionId)); } catch { }
}
